module.exports = __webpack_public_path__ + "img/某汽车企业的精准营销.637a44c3.png";